module.exports = __webpack_public_path__ + "static/media/amazonia.84d34b10.mp3";